import { lazy, type LazyExoticComponent, type ComponentType } from 'react';
import type { ArticleCtaVariant } from '../pulse';

export interface PressRelease {
  slug: string;
  /** ISO 8601 date (YYYY-MM-DD). */
  date: string;
  /** Display-friendly date with the dateline location (e.g. "Pittsburgh, PA — February 11, 2026"). */
  displayDate: string;
  title: string;
  excerpt: string;
  keywords: string[];
  /** Email address for the media contact line. */
  mediaContact?: string;
  ctaVariant?: ArticleCtaVariant;
  ctaMarketsHref?: string;
  body: LazyExoticComponent<ComponentType<{}>>;
}

export const pressReleases: PressRelease[] = [
  {
    slug: 'ophthalmic-drugs-market-module',
    date: '2026-02-11',
    displayDate: 'Pittsburgh, PA — February 11, 2026',
    title:
      'SNS Intelligence Redefines Vision Care Strategy with Launch of Advanced Ophthalmic Drugs Market Module',
    excerpt:
      'SNS Intelligence expands its Market Intelligence Platform with a dedicated Ophthalmology offering: 184 pipeline candidates across 9 therapeutic segments, with regional forecasts through 2033 across 32 countries.',
    keywords: [
      'ophthalmic drugs',
      'retinal disorders',
      'glaucoma',
      'gene therapy',
      'AAV',
      'optogenetic',
      'SNS Intelligence',
      'platform launch',
    ],
    mediaContact: 'bmahmud@snsintelligence.com',
    ctaVariant: 'trial',
    body: lazy(() => import('./ophthalmic-drugs-market-module')),
  },
  {
    slug: 'dermatology-module-launch',
    date: '2026-01-12',
    displayDate: 'Pittsburgh, PA — January 12, 2026',
    title:
      'SNS Intelligence Expands Market Intelligence Platform with Comprehensive Dermatology Module and Interactive Pipeline Analytics',
    excerpt:
      'A dedicated Dermatology offering joins the SNS Market Intelligence Platform: 216 pipeline candidates across 8 therapeutic categories, with granular regional forecasts and regulatory tracking across 26 countries.',
    keywords: [
      'dermatology module',
      'IL-23',
      'IL-17',
      'JAK inhibitors',
      'biologics',
      'psoriasis',
      'atopic dermatitis',
      'SNS Intelligence',
    ],
    mediaContact: 'BMahmud@snsintelligence.com',
    ctaVariant: 'markets',
    ctaMarketsHref: '/markets/dermatology',
    body: lazy(() => import('./dermatology-module-launch')),
  },
  {
    slug: 'platform-launch',
    date: '2026-01-12',
    displayDate: 'Pittsburgh, PA — January 12, 2026',
    title:
      'SNS Intelligence Unveils Advanced Market Intelligence Platform to Drive Life Science Strategy and Pipeline Analysis',
    excerpt:
      'SNS Intelligence launches its Market Intelligence Platform — a living data ecosystem replacing static PDF reports — headlined by Dermatology, with Ophthalmic, Cell & Gene, Biosimilars, and GLP-1 modules on the roadmap.',
    keywords: [
      'SNS Intelligence',
      'market intelligence platform',
      'pipeline analytics',
      'biopharma strategy',
      'dermatology',
      'ophthalmic',
      'cell and gene',
      'biosimilar',
      'GLP-1',
    ],
    mediaContact: 'BMahmud@snsintelligence.com',
    ctaVariant: 'trial',
    body: lazy(() => import('./platform-launch')),
  },
];

export const pressReleasesSorted: PressRelease[] = [...pressReleases].sort(
  (a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0),
);

export const getPressReleaseBySlug = (
  slug: string,
): PressRelease | undefined =>
  pressReleases.find((release) => release.slug === slug);
